/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import {
    globalTransformer,
    relatedArticlesPropsTransformer,
    headlinePropsTransformer,
} from "../../graphql/transformers";
import addMetaRobots from '../../utilities/addMetaRobots';
import sanitizeHeader from '../../utilities/sanitizeHeader';
import { sectionTitles } from './Constants';
import SharedContainer from './SharedContainer';
import genLearningCenterComponents, { handlePageChange } from './utils';
import parseHTML from '../../utilities/parseHTML';
import { sanitizeBreadcrumbs } from '../../utilities/breadcrumbs';

const LandingPageContainer = ({ data: queried, location = null, pageContext = undefined }) =>
{
    const { headerProps, footerProps } = globalTransformer({ queried, location, pageContext });
    const {currentPage, uri, description } = pageContext;
    const { page, allArticles } = queried;
    const { cdmfields: {
        choseneditory: {
            articleGridTitle,
        } = {}
    }} = page;

    const headlineProps = headlinePropsTransformer({
        name: page?.title,
        description
    });

    const parsedArticleGridTitle = parseHTML(articleGridTitle, ['learningCenter']).parsed;
    
    const recommendedArticlesProps = relatedArticlesPropsTransformer({
        title: parsedArticleGridTitle?.length ? parsedArticleGridTitle : sectionTitles.articleGridTitle,
        relatedPosts: allArticles.map(article => ({node: article})),
        handlePageChange: handlePageChange(uri),
        currentPage,
    });

    const { gridContainerComp } = genLearningCenterComponents({
        recommendedArticlesProps: [recommendedArticlesProps],
        pageContext
    });

    return <SharedContainer
        layoutProps={{headerProps, footerProps, breadcrumbProps: sanitizeBreadcrumbs(page?.cdmfields?.breadcrumb)}}
        pageProps={{gridContainerComp, headlineProps}}
    />;
};

export const Head = ({ data: queried }) =>
{
    const { headMarkup, robots } = queried?.page?.cdmfields?.metadata;
    const headMetaData = addMetaRobots(robots, headMarkup);
    return <>
        {sanitizeHeader(headMetaData).parsed}
        <html lang="en" className="smoothScroll" />
        <body data-type="blog-landing" data-id={queried?.page?.databaseId} />
    </>
}

export const pageQuery = graphql`
    query learningCenterLandingPageContainerQuery(
        $slug: String!
        $limit: Int!
        $skip: Int!
    ) {
        ...globals
        page: wpPage(slug: {eq: $slug}) {
            id
            title
            cdmfields {
                breadcrumb {
                    id
                    term_id
                    text
                    url
                }
                choseneditory {
                    featuredArticleBtnTxt
                    categoryGridTitle
                    articleGridTitle
                }
                metadata {
                    canonical
                    description
                    headMarkup
                    robots
                }
            }
        }
        allArticles: allPostsSorted (
            skip: $skip
            limit: $limit
        ) {
            ...postData
        }
        queriedFeatureArticle: featureArticle {
            ...postData
        }
    }
`;
LandingPageContainer.propTypes = {
    data: PropTypes.object.isRequired,
    location: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
        PropTypes.oneOf([null]),
    ]),
    pageContext: PropTypes.object,
}

export default LandingPageContainer;
